<template>
  <div>
    <div
      v-for="(row, colorId) in colorMatrix"
      :key="colorId"
      class="mb-4"
    >
      <div class="flex bg-grey-10 py-3 px-4 items-center rounded justify-between">
        <div class="flex items-center text-grey-70 font-semibold">
          <span
            class="h-8 w-8 rounded-full border-white mr-3"
            style="box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1); border-width: 3px"
            :style="{ backgroundColor: `#${row.color.hexcode}` }"
          />
          {{ row.color.color_name }}
        </div>

        <button
          v-if="!readOnly && Object.keys(colorMatrix).length > 1"
          class="text-blue-50 cursor-pointer"
          :title="$t('global.remove')"
          @click.prevent="removeColor(colorId)"
        >
          <i class="icon-trash-2-outline text-xl" />
        </button>
      </div>

      <!--
        TODO: i used the loop's index here to display the different states that are possible.
        Needs to be replaced once the properties are available
       -->
      <div
        v-for="(size, index) in row.sizes"
        :key="size.size"
        class="flex bg-grey-00 py-2 px-4 mt-px flex-col text-grey-90 text-sm"
      >
        <div class="flex items-center">
          <div class="w-1/6 sm:w-1/12">
            <div class="uppercase text-base mr-4">
              {{ size.size }}
            </div>
          </div>

          <div class="w-1/3 lg:w-1/3 pr-2 hidden sm:block">
            <span class="flex items-center" v-if="index === 1">
              <span class="w-1.5 h-1.5 rounded bg-green-50 mr-2 flex-shrink-0" />
              {{ $t('views.sizes_config.color_table.orderable') }}
            </span>
            <!-- TODO: Add tooltip for detailed availability -->

            <span class="flex items-center" v-else-if="index === 2">
              <span class="w-1.5 h-1.5 rounded bg-yellow-50 mr-2 flex-shrink-0" />
              {{ $t('views.sizes_config.color_table.arriving') }} {{ '18.06.' }}
            </span>

            <span class="flex items-center" v-else-if="index === 3">
              <span class="w-1.5 h-1.5 rounded bg-red-50 mr-2 flex-shrink-0" />
              {{ $t('views.sizes_config.color_table.no_arrival_date') }}
            </span>

            <span class="flex items-center" v-else>
              <span class="w-1.5 h-1.5 rounded bg-green-50 mr-2 flex-shrink-0" />
              {{ $t('views.sizes_config.color_table.in_stock') }}
            </span>
          </div>

          <div class="w-1/3 sm:w-1/6 text-left flex whitespace-no-wrap">
            <loader
              v-if="loading"
              size="small"
              color="grey-70"
              class="w-4 h-4 text-left"
            />
            <span
              v-else-if="product.avg_item_price_gross && index !== 3"
              class="leading-4 text-base"
            >
              {{ product.avg_item_price_gross | currency }}
            </span>
            <span v-else>
              –
            </span>
          </div>

          <div class="text-right ml-auto pl-2 flex items-center justify-end gap-3">
            <div class="relative">
              <button
                v-if="!readOnly && index !== 3"
                class="absolute left-0 h-full pt-1 px-3 cursor-pointer"
                :class="getSizeAmountForVariantId(size.sku) <= 0 ? 'text-gray-40' : 'text-gray-90'"
                :disabled="getSizeAmountForVariantId(size.sku) <= 0"
                @click="decrementAmount(size.sku)"
              >
                <i class="icon-minus-outline" />
              </button>

              <button
                v-if="!readOnly && index !== 3"
                class="absolute right-0 h-full pt-1 px-3 text-gray-90 cursor-pointer"
                @click="incrementAmount(size.sku)"
              >
                <i class="icon-plus-outline" />
              </button>

              <input
                type="text"
                placeholder="0"
                :value="index === 3 ? '–' : getSizeAmountForVariantId(size.sku)"
                :disabled="readOnly || index === 3"
                class="h-9 border rounded-md text-center w-full py-5 text-black"
                @change="updateSizeAmountForVariantId(size.sku, $event.target.value)"
              />
            </div>

            <i v-if="index === 4" class="icon-alert-triangle-outline text-xl text-yellow-600"></i>
            <i v-else-if="index === 3" class="text-xl w-5"></i>
            <i v-else class="icon-checkmark-circle-2-outline text-xl text-green-70"></i>
          </div>
        </div>

        <div
          v-if="index === 4"
          class="text-yellow-600 bg-yellow-00 w-full border-yellow-30 border rounded-lg flex items-center px-3 py-2 mt-2 mb-1"
        >
          <div class="pr-2 pt-1">
            <span class="icon-info-outline text-2xl" />
          </div>

          <div class="text-yellow-70">
            {{ $t('views.sizes_config.color_table.low_on_stock', {n: 12}) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ConfigProductColorTable from '../../../mixins/ConfigProductColorTable'
  import Loader from '../../layout/Loader.vue'

  export default {

    mixins: [ ConfigProductColorTable ],

    methods: {
      /**
       * @param {string} baseProductVariantId
       */
      incrementAmount(baseProductVariantId) {
        const amount = this.getSizeAmountForVariantId(baseProductVariantId) + 1
        this.updateSizeAmountForVariantId(baseProductVariantId, amount)
      },
      /**
       * @param {string} baseProductVariantId
       */
      decrementAmount(baseProductVariantId) {
        const currentAmount = this.getSizeAmountForVariantId(baseProductVariantId)
        const amount = Math.max(currentAmount - 1, 0)
        this.updateSizeAmountForVariantId(baseProductVariantId, amount)
      },
    },

    components: { Loader },

  }
</script>
